export default "__VITE_ASSET__Bcbwn1VF__"